import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  context?: string;
  loading?: boolean;
}

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  itemName,
  context,
  loading = false
}: Props) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>

      <DialogContent>
        <Typography>
          {context}
          {itemName && <strong> {itemName}</strong>}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button
          color="error"
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading && <CircularProgress size={18} />}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
